// Module
var code = "<div class=\"body main no-touch\"> <main-header/> <header-error/> <div class=\"container fc\"> <router-view/> </div> <modal-message/> <loading/> <main-footer/> </div>";
// Exports
export default code;